module.exports = __webpack_public_path__ + "img/basket-icon.5141f698.svg";